import React from "react";
import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Widerruf() {
  return (
    <LegalLayout title="Muster-Widerrufsformular" testid="withdrawal-page">
      <Section title="Widerrufsformular">
        <p className="text-gray-500">(Wenn du den Vertrag widerrufen möchtest, fülle dieses Formular aus und sende es zurück.)</p>
        <div className="mt-3 space-y-3 font-body text-sm text-gray-800">
          <p><b>An:</b><br />Mathias Walch<br />Neufeldstraße 13<br />6890 Lustenau, Österreich<br />E-Mail: office@mw3d.at</p>
          <p>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*):</p>
          <div className="border-b border-dashed border-gray-400 h-6" />
          <div className="border-b border-dashed border-gray-400 h-6" />
          <p>Bestellt am (*) / erhalten am (*): ______________________</p>
          <p>Name des/der Verbraucher(s): ______________________</p>
          <p>Anschrift des/der Verbraucher(s):</p>
          <div className="border-b border-dashed border-gray-400 h-6" />
          <p>Datum: ______________________</p>
          <p>Unterschrift (nur bei Mitteilung auf Papier): ______________________</p>
          <p className="text-gray-500">(*) Unzutreffendes streichen.</p>
        </div>
      </Section>
      <Section title="Hinweise zum Widerruf">
        <p>Du hast das Recht, binnen 14 Tagen ohne Angabe von Gründen den Vertrag über physische Produkte zu widerrufen. Weitere Informationen findest du in unseren <a href="/terms" className="underline">Nutzungsbedingungen</a>. Die Erklärung kann formlos auch per E-Mail an office@mw3d.at erfolgen.</p>
      </Section>
    </LegalLayout>
  );
}
